<template>
	<a-row :gutter="[6, 6]">
		<a-col :span="24" class="d-flex align-items-center">
			<div class="text-uppercase text-dark">
				<strong>Post categories</strong>
			</div>
			<a-tooltip placement="top" class="ml-auto mr-1 width-30">
				<template slot="title">
					<span>Filter A</span>
				</template>
				<a-button
					type="link"
					:class="[filter === 'A' ? 'btn-primary' : '']"
					class="btn btn-sm"
					@click="handleFilter('A')"
				>
					A
				</a-button>
			</a-tooltip>
			<a-tooltip placement="top" class=" mr-1 width-30">
				<template slot="title">
					<span>Filter B</span>
				</template>
				<a-button
					type="link"
					:class="[filter === 'B' ? 'btn-primary' : '']"
					class="btn btn-sm"
					@click="handleFilter('B')"
				>
					B
				</a-button>
			</a-tooltip>

			<a-tooltip placement="top">
				<template slot="title">
					<span>Create Category</span>
				</template>
				<a-button
					type="link"
					class="btn btn-sm btn-light"
					@click="() => (modalCategory = true)"
				>
					<a-icon type="plus" />
				</a-button>
			</a-tooltip>
		</a-col>

		<a-col :span="8" v-for="(category, index) in categoryList" :key="index">
			<div class="item p-2 d-flex border-gray-2">
				<a-tooltip placement="top">
					<template slot="title">
						<span v-if="category.isMainCategory === 1"
							>{{ 'Category A' }}
						</span>
						<span v-else>{{ 'Category B' }} </span>
					</template>
					<a
						href="javascript: void(0);"
						class="btn btn-sm btn-light mr-2 width-30"
						v-if="category.isMainCategory === 1"
					>
						{{ 'A' }}
					</a>
					<a
						href="javascript: void(0);"
						class="btn btn-sm btn-light mr-2 width-30"
						v-else
					>
						{{ 'B' }}
					</a>
				</a-tooltip>

				<span>{{ category.code }} </span>
				<a-button
					type="link"
					size="small"
					class="ml-auto text-danger"
					@click="handleCategoryDelete(category)"
				>
					<a-icon type="delete" />
				</a-button>
			</div>
		</a-col>

		<a-modal
			title="New Category"
			:visible="modalCategory"
			@ok="handleOkCategory"
			:confirm-loading="confirmLoading"
			@cancel="handleCancelCategory"
		>
			<a-form
				:form="categoryForm"
				:label-col="{ span: 5 }"
				:wrapper-col="{ span: 12 }"
			>
				<a-form-item label="Code">
					<a-input
						v-decorator="[
							'code',
							{
								rules: [{ required: true, message: 'Please input some code' }],
							},
						]"
					/>
				</a-form-item>
				<a-form-item label="Type">
					<a-select
						v-decorator="[
							'isMainCategory',
							{
								initialValue: 1,
								rules: [
									{ required: true, message: 'Please select category type' },
								],
							},
						]"
						placeholder="Select a option and change input text above"
					>
						<a-select-option
							v-for="(cat, index) in isMainCategory"
							:value="cat.isMainCategory"
							:key="index"
						>
							{{ cat.typeName }}
						</a-select-option>
					</a-select>
				</a-form-item>
			</a-form>
		</a-modal>
	</a-row>
</template>

<script>
import { mapActions } from 'vuex'
import { CATEGORY as CATEGORIES_ACTIONS } from '@/store/actions'

export default {
	components: {},
	data: function() {
		return {
			catA: [],
			catB: [],
			categoryList: [],
			code: '',
			isMainCategory: [
				{
					isMainCategory: 1,
					typeName: 'A',
				},
				{
					isMainCategory: 0,
					typeName: 'B',
				},
			],
			filter: 'A',
			loading: true,
			modalCategory: false,
			categoryForm: this.$form.createForm(this),
			confirmLoading: false,
		}
	},
	created() {
		this.loadCategories().then(res => {
			if (res) {
				this.catA = res.main
				this.catB = res.sub
				this.categoryList = res.main
				this.loading = false
			}
		})
	},
	methods: {
		handleFilter(filter) {
			if (filter === 'A') {
				this.categoryList = this.catA
			} else {
				this.categoryList = this.catB
			}
		},
		handleCategoryDelete(category) {
			this.$confirm({
				title: 'Delete the following Category?',
				content: category.code,
				okText: 'Yes',
				okType: 'success',
				cancelText: 'No',
				onOk: () => {
					this.deleteCategory(category)
				},
			})
		},
		handleOkCategory(e) {
			this.categoryForm.validateFields((err, values) => {
				if (!err) {
					this.confirmLoading = true
					this.createCategory({
						code: values.code,
						isMainCategory: values.isMainCategory,
					})
						.then(e => {
							this.categoryForm.resetFields()
							this.$notification.success('Category created')
						})
						.catch(e => {
							this.$notification.error('Whoops something broke')
						})
						.finally(() => {
							this.modalCategory = false
							this.confirmLoading = false
						})
				}
			})
		},
		handleCancelCategory() {
			this.modalCategory = false
			this.category = null
		},
		...mapActions({
			createCategory: CATEGORIES_ACTIONS.CREATE,
			loadCategories: CATEGORIES_ACTIONS.LIST,
			deleteCategory: CATEGORIES_ACTIONS.DELETE,
		}),
	},
}
</script>

<style lang="scss">
@import '@/assets/styles/mixins.scss';
.item:hover {
	background-color: $gray-1;
}
</style>
